import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true, state: {
        loading: false,
        invoices: {data: [], current_page: 1, total: 0, per_page: 10},
        marking_paid: false,
    }, getters: {
        loading: state => state.loading,
        invoices: state => state.invoices,
        marking_paid: state => state.marking_paid,
    }, mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setInvoices(state, data) {
            state.invoices = data
        },
        setMarkingPaid(state, val) {
            state.marking_paid = val
        },
    }, actions: {
        async getLandlordInvoices({commit}, filters) {
            try {
                commit('setLoading', true)
                const response = await api.getLandlordInvoices(filters);
                commit('setInvoices', response.data);
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async markLandlordInvoicePaid({commit}, {id, data}) {
            try {
                commit('setMarkingPaid', true)
                const response = await api.markLandlordInvoicePaid(id, data);
                commit('setMarkingPaid', false)
                ElMessage.success(response.message || 'Invoice marked as paid!');
                return response;
            } catch (e) {
                commit('setMarkingPaid', false)
                ElMessage.error(e.response.data.message);
                throw e;
            }
        },
    }
}
